import {FC} from 'react'

import AlternativeRegister from '@progyny/pages/Register/AlternativeRegister'

const ISN: FC = () => (
  <AlternativeRegister
    firstField={{
      name: 'employeeId',
      labelKey: 'register_employee_id',
      placeholder: '123456',
      invalidMessageKey: 'register_invalid_employee_id',
    }}
    secondField={{
      name: 'employeeZip',
      labelKey: 'register_isn_employee_zip',
      placeholder: '12345',
      invalidMessageKey: 'register_isn_invalid_employee_zip',
    }}
    submitButtonLabelKey='register_send_confirmation_email'
    alternativeISN
  />
)

export default ISN
